let EventType;

(function (EventType) {
  EventType["TimeToFirstByte"] = "ttfb";
  EventType["TimeToLastByte"] = "ttlb";
  EventType["TimeToFirstPaint"] = "ttfp";
  EventType["TimeToFirstContentfulPaint"] = "ttfcp";
  EventType["TimeToLargestContentfulPaint"] = "ttlcp";
  EventType["DomContentLoaded"] = "dcl";
  EventType["FirstInputDelay"] = "fid";
  EventType["Load"] = "load";
  EventType["LongTask"] = "longtask";
  EventType["Usable"] = "usable";
  EventType["GraphQL"] = "graphql";
  EventType["ScriptDownload"] = "script";
  EventType["StyleDownload"] = "style";
  EventType["RedirectDuration"] = "redirect_duration";
})(EventType || (EventType = {}));

let NavigationResult;

(function (NavigationResult) {
  NavigationResult[NavigationResult["Finished"] = 0] = "Finished";
  NavigationResult[NavigationResult["TimedOut"] = 1] = "TimedOut";
  NavigationResult[NavigationResult["Cancelled"] = 2] = "Cancelled";
})(NavigationResult || (NavigationResult = {}));

export { EventType, NavigationResult };
